const DeleteAllIcon = () => {
    return (
        <img
            style={{ width: '100%', height: '100%' }}
            src="/images/delete-all-icon.svg"
            alt="Document Icon"
        />
    );
};

export default DeleteAllIcon;
